import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfNewBrunswick = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of New Brunswick (UNB)"
      universityShortName="UNB"
      slug="university-of-new-brunswick"
      seoTitle="UNB Study Rooms | Fredericton & Saint John Campus Study Guide"
      seoDescription="Complete guide to study rooms at University of New Brunswick. Find Harriet Irving Library, group rooms, and LCD-equipped spaces. Plus free 24/7 online alternative."
      seoKeywords="unb study rooms, university of new brunswick library, harriet irving library, fredericton university study spaces, unb saint john"
      canonicalUrl="/study-room/university-of-new-brunswick/"
      heroDescription="A comprehensive guide to study rooms at UNB in Fredericton and Saint John, including tech-equipped group rooms."
      libraryWebsiteUrl="https://lib.unb.ca/"
      libraryWebsiteName="UNB Libraries"
      studySpaces={[
        {
          name: "Group Study Rooms",
          features: "Seat 5-8 people with 46-70 inch LCD screens and wireless presentation systems. Require at least three students to book.",
          feedback: "Technology appreciated but minimum group size and no back-to-back bookings are frustrating."
        },
        {
          name: "Small Study Rooms (5th Floor, Harriet Irving)",
          features: "Smaller rooms for solo or duo study; bookable via LibCal.",
          feedback: "Good for individual focused work."
        },
        {
          name: "Research Commons",
          features: "Collaborative research space for academic work.",
          feedback: "Useful for research-focused students."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Plan group meetings carefully and ensure <strong>at least three members show up</strong>. Arrive early to check in by scanning the QR code. Spaces may be booked for up to three hours once per day, up to seven days in advance.
          </p>
          <p className="mb-4">
            <strong>Back-to-back bookings are not allowed</strong>, and a 10-minute check-in rule applies. If you need solo study space, use <strong>small study rooms on the fifth floor</strong> of Harriet Irving Library.
          </p>
          <p>
            Students appreciate the technology but dislike the strict minimum group size and the prohibition on back-to-back bookings. Snacks and covered drinks are allowed as long as the room is left clean.
          </p>
        </>
      }
      summaryTips={[
        "Bring at least three people: Minimum group size required for group rooms.",
        "Check in within 10 minutes: QR code check-in required to keep your booking.",
        "No back-to-back bookings: Plan around this restriction.",
        "Use fifth-floor small rooms: Good for solo study via LibCal booking.",
        "Use CSW for flexibility: No minimum group sizes or back-to-back restrictions."
      ]}
    />
  );
};

export default UniversityOfNewBrunswick;
